import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreTo,
  moreLabel = '查看全部',
}: SectionHeadingProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6 md:mb-8">
      <div className="min-w-0">
        {eyebrow && (
          <p className="font-label text-xs text-accent-400 tracking-[0.28em] mb-2">{eyebrow}</p>
        )}
        <h2 className="text-xl md:text-2xl text-foreground-950 font-bold flex items-center gap-3">
          <span className="w-1 h-6 bg-primary-500 rounded-full" />
          {title}
        </h2>
        {description && <p className="mt-2 text-sm text-foreground-600 max-w-2xl">{description}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}